import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { focusRing } from "../../design-system/focusRing";

// Full-width outlined action, as the prototype uses for the rail's
// "Integration hinzufügen". Deliberately not a filled primary button: it sits
// directly under the organization switcher and a solid cyan block there
// out-shouts the navigation. `active` marks the section it leads to as current,
// tinting the border and background instead of filling them.
const Block = styled.button`
    ${focusRing}
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--gap-m);
    width: 100%;
    min-width: 0;
    padding: 10px;
    border: 1px solid ${(props) => (props.$active ? "var(--pw-brand-cyan)" : "var(--border-strong)")};
    border-radius: var(--pw-radius-lg);
    background: ${(props) => (props.$active ? "var(--pw-tint-brand)" : "var(--surface-card)")};
    color: var(--text-heading);
    font-family: inherit;
    font-size: var(--pw-text-control);
    /* The prototype's is 38px: same padding and font as ours, but the label line is not stretched to 1.5,
       which was the whole four-pixel difference. */
    line-height: var(--pw-leading-tight);
    font-weight: ${(props) => (props.$active ? "var(--pw-weight-semibold)" : "var(--pw-weight-regular)")};
    cursor: pointer;
    transition: background var(--pw-transition-fast) var(--pw-ease),
        border-color var(--pw-transition-fast) var(--pw-ease);

    &:hover:not(:disabled) {
        border-color: var(--pw-brand-cyan);
        background: var(--pw-tint-brand);
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

const Icon = styled.span`
    display: inline-flex;
    align-items: center;
    flex: none;
    font-size: var(--pw-text-sm);
`;

export const PathwayBlockButton = ({ children, icon, active = false, disabled = false, onClick, dataCy }) => (
    <Block
        type="button"
        $active={active}
        disabled={disabled}
        aria-current={active ? "page" : undefined}
        onClick={onClick}
        data-cy={dataCy}
    >
        {icon && <Icon>{icon}</Icon>}
        {children}
    </Block>
);

PathwayBlockButton.propTypes = {
    children: PropTypes.node.isRequired,
    icon: PropTypes.node,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    dataCy: PropTypes.string,
};

export default PathwayBlockButton;
